module.exports = "/images/vendor/flag-icon-css/flags/4x3/cy.svg?d069616cbc4fb181cdadc171a5038ff2";